<template>
  <div class="app-layout">
    <AppSidebar />
    <div class="app-main">
      <AppHeader :tabs="tabs" @activate-tab="activateTab" @close-tab="closeTab" @close-other-tabs="closeOtherTabs" />
      <main class="app-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar.vue'
import AppHeader from '@/components/AppHeader.vue'
import { findRoute } from '@/config/channels'
export default {
  name: 'AppLayout',
  components: { AppSidebar, AppHeader },
  data() {
    return {
      tabs: []
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() { this.syncRouteTab() }
    }
  },
  methods: {
    syncRouteTab() {
      const path = this.$route.path
      if (!path || (path !== '/ops' && !this.$route.params.channel)) return
      const existing = this.tabs.find(tab => tab.path === path)
      if (existing) return
      const params = this.$route.params
      const route = findRoute(params.channel, params.type)
      const tab = path === '/ops'
        ? { path, title: '运行概览' }
        : { path, title: route ? route.title : '渠道设置' }
      this.tabs.push(tab)
    },
    activateTab(tab) {
      if (tab.path !== this.$route.path) this.$router.push(tab.path)
    },
    closeTab(index) {
      const closing = this.tabs[index]
      if (!closing) return
      this.tabs.splice(index, 1)
      if (closing.path === this.$route.path && this.tabs.length) {
        const next = this.tabs[Math.max(0, index - 1)]
        this.$router.push(next.path)
      }
    },
    closeOtherTabs() {
      const current = this.tabs.find(tab => tab.path === this.$route.path)
      this.tabs = current ? [current] : []
    }
  }
}
</script>

<style lang="scss" scoped>
.app-layout {
  display: flex;
  height: 100%;
  min-width: 320px;
}

.app-main {
  flex: 1;
  min-width: 0; // 允许 flex 子项收缩，防止内容撑破布局
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1;
  padding: 24px 28px 32px;
  overflow: auto;
  background: var(--bg-page);
}

@media (max-width: 700px) {
  .app-content {
    padding: 16px 14px 24px;
  }
}
</style>
